window.Listing = {

	allLinkedIds : [],

	getListingName : function(){
		return $('#listingname').length > 0 ? $('#listingname').val() : '';
	},

	/**
	 * 
	 * @param {String} prefix
	 * @returns {undefined}
	 */
	init: function(prefix, callback){
		Sidebar.init();

		if(Utils.exists(prefix+"_checkStep")){
			Listing.updateSteps(prefix);
		}
		
		Listing.displaySortBy(prefix, $("#"+prefix+"_sortField").val());
		
		if($('.linkinlist').length === 0){
			Listing.groupedActionChecker();
		}
		
		$('.filter_toplabel:not(.filtersearch_label)').on('click', function(){
			$(this).closest('.filter-group').toggleClass('open');
		});
		
		Listing.freezeFilters();
		
		if($('select.mutlipleSelect').length > 0){
			$('select.mutlipleSelect').multipleSelect({
				placeholder		: Loc.g("Choisissez des valeurs"),
				width			: 245,
				selectAll		: false,
				position		: 'bottom',
				countSelected	: false,
				selectAllText: Loc.g('Tout Sélectionner'),
				allSelected: Loc.g('Tous sélectionnés'),
				onClick			: function(view) {
					
					var containListing = prefix.indexOf("Listing");
					
					if (containListing == -1){
						Listing.update(prefix+"Listing");
					} else {
						Listing.update(prefix);
					}
				}
			});
		}

        // Multiple select staff with group
        var multipleSelectOptions = {
            width			: 300,
			countSelected	: false,
            selectAll		: false,
			selectAllText: Loc.g('Tout Sélectionner'),
			allSelected: Loc.g('Tous sélectionnés'),
            onOptgroupClick	: function(view){
                Listing.update(prefix);
            },
            onClick			: function(view) {
                Listing.update(prefix);
            }
        };

		var staffGroup = $('select.staffGroup').length > 0 ? $('select.staffGroup') : null;
		staffGroup && staffGroup.multipleSelect(multipleSelectOptions);

		//On modifie le placement des éléments
		$("#staffGroup li:not(.group)").css('margin-left', '15px');
        // End multiple select
		
		Listing.initSelectColumns(prefix);
		
		if(Utils.browserDetails.name !== 'Apple Safari' && $('#'+prefix+'_container table.listingtable').find('th.th-draggable').length > 0) {
			Listing.initDragTable(prefix);
		}
		
		if (callback !== undefined){
			eval(callback);
		}
		
		if (prefix == 'booksListing') {
			Qtip.init();
		}
		
		MyFacture.stopWait();
		
	},
	
	
	
	initDragTable : function(prefix){
		var initOrder		= [];
		var cptOrder		= 0;
		var lastOrder		= 0;
		var $listingTable	= $('#'+prefix+'_container table.listingtable');
                
		if($listingTable.find('th#groupedActions').length > 0){
			initOrder['groupedActions'] = 1;
			cptOrder					= 1;
			lastOrder					= cptOrder;
		}
		
		$listingTable.find('th.th-draggable').each(function(){
			var rank = $(this).attr('data-rank');
			
			if(rank != '' && rank != undefined){
				initOrder[$(this).attr('id')]	=  parseInt(rank, 10) + cptOrder;
                lastOrder						= parseInt(rank, 10) + cptOrder;
			}
		});
                
		initOrder['listActions'] = 999;

		var sortable = [];
		
		for (var tmp in initOrder){
			sortable.push([tmp, initOrder[tmp]]);
		}

		sortable.sort(function(a, b) {
			return a[1] - b[1];
		});

		initOrder = [];
		
		for(var key in sortable) {
			var value = sortable[key];
			initOrder[value[0]] = value[1];
		}
                
		$listingTable.dragtable({
			
			maxMovingRows	: 1,
			dragHandle		: '.col-handler',
			dragaccept		: '.th-draggable',
			containment		: 'parent',	
		persistState	: function(table) { 
				
				table.el.find('th.th-draggable').each(function(i) { 
					
					if($(this).css('display') != 'none'){
						
						var colname = $(this).attr('data-colname');
						table.sortOrder[colname] = i;
						
					}
					
				}); 
				
				$('#'+prefix+'_displayedColumnsContainer').empty();
                                
				for(var i in table.sortOrder){
					
					var $inputs = $('<input />').attr('type', 'hidden')
												.attr('name', prefix+'_displayedColumns['+table.sortOrder[i]+']')
												.attr('id', prefix+'_displayedColumns['+table.sortOrder[i]+']')
												.val(i);
										
					$inputs.appendTo('#'+prefix+'_displayedColumnsContainer');
					
				}
				
				Listing.updateColumnDisplay(prefix);
				
			},
			restoreState : initOrder
		});
		
	},
	
	initSelectColumns : function(prefix){
		
		var $listingColumns		= $("div[id='"+prefix+"_columnsSelect']");
		var $listingContains	= $('#'+prefix+'_container');

		$listingColumns.first().find('select').multipleSelect({
			placeholder		: Loc.g("Sélectionnez les colonnes à afficher / masquer"),
			selectAll		: false,
			countSelected	: false,
			selectAllText: Loc.g('Tout Sélectionner'),
			allSelected: Loc.g('Tous sélectionnés'),
			onClick			: function(view) {
				
				$('#'+prefix+'_displayedColumnsContainer').empty();
				var selects = $listingColumns.first().find('#'+prefix+'_columns').multipleSelect('getSelects');

				if(view.checked === true){
					$listingContains.find('th[data-colname=\''+view.value+'\'], td[data-colname=\''+view.value+'\']').show();
				}else{
					$listingContains.find('th[data-colname=\''+view.value+'\'], td[data-colname=\''+view.value+'\']').hide();
				}

				var cpt = 0;
				
				$listingContains.find('th.th-draggable').each(function(){
					
					if(Utils.in_array($(this).attr('data-colname'), selects)){
						var $inputs = $('<input />').attr('type', 'hidden').attr('name', prefix+'_displayedColumns['+cpt+']').attr('id', prefix+'_displayedColumns['+cpt+']').val($(this).attr('data-colname'));
						$inputs.appendTo('#'+prefix+'_displayedColumnsContainer');
						cpt++;
					}
					
				});

				if($('.displayColumns').length > 1){
					$listingColumns.last().find('select').multipleSelect('setSelects', selects);
				}
				
				Listing.updateColumnDisplay(prefix);
			}
		});
		
		
		if($listingColumns.length > 1){
			$listingColumns.last().find('select').multipleSelect({
				selectAll		: false,
				placeholder		: Loc.g("Sélectionnez les colonnes à afficher / masquer"),
				countSelected	: false,
				onClick			: function(view) {
					
					var selects = $(".displayColumns:last").find('select').multipleSelect('getSelects');
					$(".displayColumns:first").find('select').multipleSelect('setSelects', selects);
					$('#'+prefix+'_displayedColumnsContainer').empty();
					
					if(view.checked === true){
						$listingContains.find('th[data-colname=\''+view.value+'\'], td[data-colname=\''+view.value+'\']').show();
					}else{
						$listingContains.find('th[data-colname=\''+view.value+'\'], td[data-colname=\''+view.value+'\']').hide();
					}

					var cpt = 0;
					$listingContains.find('th.th-draggable').each(function(){
						if(Utils.in_array($(this).attr('data-colname'), selects)){
							var $inputs = $('<input />').attr('type', 'hidden').attr('name', prefix+'_displayedColumns['+cpt+']').attr('id', prefix+'_displayedColumns['+cpt+']').val($(this).attr('data-colname'));
							$inputs.appendTo('#'+prefix+'_displayedColumnsContainer');
							cpt++;
						}
					});

					Listing.updateColumnDisplay(prefix);
				}
			});
		}
	},
	
	/**
	 * 
	 * @param {type} me
	 * @returns {undefined}
	 */
	groupedActiontoggler: function(me, toHide){

		toHide = toHide == undefined ? false : toHide;

		if (me.hasClass('toggled') || toHide){
			
			me.removeClass('toggled');
			$('#groupedActionContainer').hide();
			$('.groupedActionChecker').prop('checked', false); //.next().removeClass('ui-state-active');
			$('.listingTools').show();
			
		} else {
			
			me.addClass('toggled');
			
			if ($(".groupedActionChecker[canbesharedbyloggedstaff='N']:checked").length > 0){
				$("#groupedAction option[value='share']").attr('disabled', 'disabled');
			} else {
				$("#groupedAction option[value='share']").removeAttr('disabled');
			}
			
			Listing.checkSelectAllPages();
			$('#groupedActionContainer').show();
			$('.groupedActionChecker').prop('checked', true); //.next().addClass('ui-state-active');
			$('.listingTools').hide();
		}

	},


	/**
	 * 
	 * @returns {undefined}
	 */
	groupedActionChecker: function(){

		$(document).on('click', '.groupedActionChecker', function(){

			if ($('.groupedActionChecker:checked').length > 0 && !$('#groupedActionContainer').is('visible')){
				
				/**************************************************************************************************************/
				// pour le listing des items => pour les action groupée, on affiche seulement celle qui ont la class okForDecli
				Listing.hideGroupedAction();
				/**************************************************************************************************************/
				
				$('#groupedActionContainer').show();
				$('.listingTools').hide();

				Listing.checkSelectAllPages();

			} else {
				if ($('.groupedActionChecker:checked').length === 0){
					
					$('#groupedActionContainer').hide();
					$('.listingTools').show();
				}
			}
			
		});

		if($('#selectAllPages').length > 0) { 
			$('#groupedAction').change(function(){
				Listing.checkSelectAllPages();
			});
		}

	},

	/**
	 * 
	 * @returns {undefined}
	 */
	hideGroupedAction : function(){
		
		if($('#groupedActionContainer').hasClass('itemsListingGroupedAction')){
			
			var hideGroupedActionItemDecli = false;
			
			$(".groupedActionChecker:checked").each(function(){
				if(!hideGroupedActionItemDecli){
					var element = $(this).attr('checkervalue');
					var splitElem = element.split("_");
					if(splitElem[2] !== '0'){
						hideGroupedActionItemDecli = true;
					}
				}
			});
			
			if(hideGroupedActionItemDecli){
				
				$("#groupedAction option:not(.okFordecli)").hide();
				$('#groupedAction option[value="nothing"]').prop('selected', true);
				
			} else{
				
				$("#groupedAction option").show();
				
			}
		}
		
	},
	
	
	/**
	 * 
	 * @returns {undefined}
	 */
	groupedAction: function(){

		Listing.allLinkedIds = false;

		var selectedAction	= $('#groupedAction option:selected').val();
		var listingObject	= $('#shareType').val();
		var doctype			= $('#doctype').val();
		var selectAllPages	= $('#selectAllPages').is(':checked');

		var listingname 	= Listing.getListingName().replace('Listing', 'List').replace('List', '');
		
		var rowSelection = $('.groupedActionChecker:checked').map(function () {
			return $(this).attr('checkerValue');
		}).get();
		
		if (rowSelection === "" || rowSelection.length === 0) {
			MyWindow.alert(Loc.g("vous n'avez sélectionné aucune ligne dans votre liste"), { type: "error" });
			return;
		}

		if(selectedAction.length > 0 && selectedAction !== 'nothing'){

			selectAllPages && Listing.getAllElementsIds(rowSelection[0].split('_')[0]);

			var rowSelection = (selectAllPages && Listing.allLinkedIds.length > 0) ? Listing.allLinkedIds : rowSelection;

		}
        
		switch (selectedAction){
			case "rent_createFromGoodsList":
				rentBook.createFroGoodsList(rowSelection);
				break;
			
			case "massChaseDoc":
				DocMassChase.massChaseForm(rowSelection);
				break;
			
			case "forceDoctsDoctypeSteps":
				DocMassSteps.massStepsForm(rowSelection, 'Y');
				break;
			
			case "forceDocsSteps":
				DocMassSteps.massStepsForm(rowSelection);
				break;
			
			case "editItemsCategory":
				ItemsCategory.editItemsCategory(rowSelection);
				break;
			
			case "tt_markAsBillable":
				TimetrackingEntry.massToggleBillable(rowSelection, 'Y');
				break;
				
			case "tt_markAsnotBillable":
				TimetrackingEntry.massToggleBillable(rowSelection, 'N');
				break;
			
			case "addTradeNameToNote":
				Catalogue.massEditTradeNameToNode(rowSelection, 'add');
				break;
			
			case "deleteTradeNameToNote":
				Catalogue.massEditTradeNameToNode(rowSelection, 'delete');
				break;
			
			case "switchWarehouse":
				Stock.massswitchStockSerialWh(rowSelection);
				break;
			
			case "outStock":
				Stock.massStockSerialInOut(rowSelection, 'out');
				break;

			case "inStock":
				Stock.massStockSerialInOut(rowSelection, 'in');
				break;

			case "massResetBooking":
				Stock.massResetBooking(rowSelection);
				break;

			case "resetBooking":
				Stock.resetBooking(rowSelection, 'in');
				break;

			case "removecompta":
				AccountingEntries.massCompta(doctype, rowSelection, 'remove');
				break;
			
			case "compta":
				AccountingEntries.massCompta(doctype, rowSelection, 'mark');
				break;
			
			case "payment_removecompta":
				AccountingEntries.paymentMassCompta(rowSelection, 'remove');
				break;
			
			case "payment_compta":
				AccountingEntries.paymentMassCompta(rowSelection, 'mark');
				break;
			
			case "share":
				Sharepoint.massEditForm(listingObject, rowSelection);
				break;
				
			case "updateStateThird" : 
				Third.updateState(rowSelection);
				break;
				
			case "updateStatePeople" : 
				People.updateState(rowSelection);
				break;
				
			case "deleteThirds":
				Third.deletethirdsGroupAction(rowSelection);
				break;

			case "harddelete":
				Third.harddelete(rowSelection);
				break;
			
			case "deletePeoples":
				People.deletepeoplesGroupAction(rowSelection);
				break;
				
			case "updateStateItem" : 
				Catalogue.updateState(rowSelection);
				break;
				
			case "inbank":
				Payment.massBankDeposit(listingObject, rowSelection);
				break;
				
			case "viewInPos":
				Catalogue.switchPosView('Y', listingObject, rowSelection);
				break;
				
			case "noviewInPos":
				Catalogue.switchPosView('N', listingObject, rowSelection);
				break;
				
			case "timeTrackignEnabled":
				Catalogue.switchTimetrackingEnabled('Y', listingObject, rowSelection);
				break;
			
			case "removeTimeTrackignEnabled":
				Catalogue.switchTimetrackingEnabled('N', listingObject, rowSelection);
				break;
				
			case "editNewItemVat":
				Catalogue.editNewItemVat(listingObject, rowSelection);
				break;
				
            case "zip":
            
                var filesIds = [];
                $('.groupedActionChecker:checked').each(function () {

                    var fileId = parseInt($(this).attr('fileId'), 10);

                    if(fileId > 0){
                        filesIds.push(fileId);
                    }
                });
                
				var ressources = {
					files: filesIds,
					folders:{}
				};

				BriefCaseV2Light.downloadArchive('POST', '/?_f=briefcasev2', {
					action		: 'groupedAction',
					todo		: 'downloadzip',
					ressources	: ressources,
				});

				break;
				
			case "purZip":
				var docIds = $('.groupedActionChecker:checked').map(function() {
					return $(this).attr('id');
				}).get();
				
				var ressources = {listingname: listingname, docs:docIds};

				BriefCaseV2Light.downloadArchive('POST', '/?_f=briefcasev2', {
					action		: 'groupedAction',
					todo		: 'downloadpurzip',
					ressources	: ressources,
				});
				
				break;

			case "expZip":
				var docIds = $('.groupedActionChecker:checked').map(function() {
					return $(this).attr('id');
				}).get();
				
				var ressources = {docs:docIds};

				BriefCaseV2Light.downloadArchive('POST', '/?_f=briefcasev2', {
					action		: 'groupedAction',
					todo		: 'downloadexpzip',
					ressources	: ressources,
				});

				break;

			case 'email_massDelete' : 
				Email.massDelete();
				break;
				
			case 'email_massRead' : 
				Email.massStep(listingObject, rowSelection, 'read');
				break;
			
			case 'email_massUnread' : 
				Email.massStep(listingObject, rowSelection, 'unread');
				break;



			case 'email_BatchDelete':
				EmailBox.batchDelete(rowSelection);
				break;
			case 'email_BatchLink':
				EmailBox.batchLink(rowSelection);
				break;
			case 'email_BatchRead':
				EmailBox.batchRead(rowSelection, true);
				break;
			case 'email_BatchUnread':
				EmailBox.batchRead(rowSelection, false);
				break;
			case 'email_BatchStarred':
				EmailBox.batchStarred(rowSelection, true);
				break;
			case 'email_BatchUnstarred':
				EmailBox.batchStarred(rowSelection, false);
				break;
			
			
			case 'opportunity' :
				Opportunity.addGroupedOpportunity(rowSelection);
				break;

			case 'completeTasks' :
				Agenda.completeTaskBatch(rowSelection);
				break;
			
			case 'uncompleteTasks' :
				Agenda.uncompleteTaskBatch(rowSelection);
				break;
			
			case 'changeDateTasks' :
				Agenda.changeDateTaskBatch(rowSelection);
				break;
			
			case 'deleteBatchTasks' :
                Agenda.deleteTaskBatch(rowSelection);
                break;

			case 'changeOwnerTasks' :
				Agenda.changeOwnerTaskBatch(rowSelection);
				break;
			
			case 'changeStaffTasks' :
				Agenda.changeStaffTaskBatch(rowSelection);
				break;
			
			case 'statut' :
				Support.massUpdateStatus(rowSelection);
				break;
			
			case 'assignTo' :
				Support.massUpdateStaff(rowSelection);
				break;
			
			case 'tags' :
				Support.massAddTag(rowSelection);
				break;
			
			case 'groupTickets' :
				Support.groupTickets(rowSelection);
				break;
			
			case 'purInvoice' :
				PurDocInvoices.createFromDeliveries(rowSelection);
				break;
			
			case 'purDelivery' :
				PurDocDeliveries.createFromOrders(rowSelection);
				break;
				
			case 'invoice' :
				DocInvoices.createFromDeliveries(rowSelection);
				break;
			
			case 'docFusion':
				DocFusion.init(rowSelection);
				break;
			
			case 'exp_refuse' :
				expenses.massRefuse(rowSelection);
				break;
			
			case 'exp_accept' :
				expenses.massAccept(rowSelection);
				break;
			
			case 'massmailing_mailinglist' :
				MailingList.addToOne(rowSelection);
				break;

			case 'massmailing_unsubscribeRecipientBounce' :
				Campaign.unsubscribeRecipientBounce(rowSelection);
				break;
				
			case 'deleteItem' :
				Catalogue.deleteItemGroupAction(rowSelection);
				break;
				
			case "exportSepa":
				SepaExport.massSepaExport(rowSelection);
				break;

            case "purExportSepa":
                SepaExport.massPurSepaExport(rowSelection);
                break;
			
			case "recordMassPayments":
				MassPayment.massPaymentForm(rowSelection, listingObject);
				break;
			
			case "deleteopportunities":
				Opportunity.deleteOpportunities(rowSelection);
				break;

			case "deletePromotions":
				ItemPromo.MassdeletePromotions(rowSelection);
				break;
				
			case "addPromotions":
				
				var rowSelection = $('.groupedActionChecker:checked').map(function () {
					return $(this).attr('checkerValue2');
				}).get();

				if (rowSelection === "" || rowSelection.length == 0){
					MyWindow.alert(Loc.g("vous n'avez sélectionné aucune ligne dans votre liste"), {type:'error'});
					return;
				}
				
				ItemPromo.massAddPromotions(rowSelection);
				
				break;	
			
			case "stopPromotions":
				ItemPromo.massStopPromotions(rowSelection);
				break;
			
			case "playPromotions":
				ItemPromo.massPlayPromotions(rowSelection);
				break;	
			
			case "finishPromotions":
				ItemPromo.massFinishPromotions(rowSelection);
				break;				
			
			case "addMassTags":
				if(['doc','pur'].indexOf(listingObject) !== -1){
					Tag.massEditForm(doctype, rowSelection);
				} else{
					Tag.massEditForm(listingObject, rowSelection);
				}
				break;
			
			case "assignMassStaff":
				Opportunity.massAssignStaffForm(rowSelection);
				break;

			case "moveOpportunities":
				Opportunity.moveOpportunities(rowSelection);
				break;
			
			case "updateStatusOpp":
				Opportunity.updateStatusOpp(rowSelection);
				break;

			case "updateDueDateOpp":
				Opportunity.updateDueDateOpp(rowSelection);
				break;

            case "updateSourceOpp":
                Opportunity.updateSourceOpp(rowSelection);
                break;

			case "massEditCustomFields":
				CustomFieldForm.massEditForm(listingObject, rowSelection, listingname);
				break;

			case "modifyCorpAddress":
				DocFormv2.editAddress('corp', 'doc', rowSelection);
				break;

			case "transformProspectToClient":
                Thirds.transformThirds('client', rowSelection);
                break;
                
            case "transformClientToProspect":
                Thirds.transformThirds('prospect', rowSelection);
                break;

			case "subscribeCampaignThirds":
				Third.subscribeCampaignThirds(rowSelection, listingObject, listingname);
				break;

			case "unsubscribeCampaignThirds":
				Third.unsubscribeCampaignThirds(rowSelection, listingObject, listingname);
				break;

			case "createTask":
				Agenda.createMassTask(listingObject, rowSelection);
				break;

			case "massTogglePublicLink":
				DocOverview.togglePublicLink(doctype, rowSelection);
				break;
				
			case "gocardless_massRetried":
				GoCardless.massRetried(rowSelection);
				break;
				
			case "gocardless_mandateReminder":
					GoCardless.massMandateReminder(rowSelection);
				break;
				
			case "gocardless_recordMassDirectdebits":
				GoCardless.recordMassDirectdebits(rowSelection);
				break;
				
			case "gocardless_massDeleteMandate":
				GoCardless.recordMassDeleteMandate(rowSelection);
				break;
					
			case "massSetAsConfirmed":
				MassPayment.massSetAsConfirmed(rowSelection);
				break;

            case "transformThirdType":
                Third.transformThirdType(rowSelection, 'corporation');
                break;
			
			case "stripe_massCancelled" :
				ExtStripe.cancelMassDirectdebit(rowSelection);
				break;
			default:
				MyWindow.alert(Loc.g("Vous n’avez selectionné aucune action !"), {type:'error'});
				break;
				
		}

		$('#selectAllPages').removeAttr('checked');

	},
	
	/**
	 * @param {String} action (show|hide)
	 * @param {String|undefined} listingName
	 */
	loader: function(action, listingName){

		if(listingName == undefined) listingName = Listing.getListingName();

		// toggle
		if (['show', 'hide'].indexOf(action) == -1) action = $("#" + listingName + "_listingLoader").is(':hidden') ? 'show' : 'hide';

		switch(action){
			case 'show':
				$("#" + listingName + "_listingLoader:hidden").fadeIn();
				break;
			case 'hide':
				$("#" + listingName + "_listingLoader:visible").hide();
				break;
		}

	},

	/**
	 * 
	 * @param {String} listingPrefix
	 * @param {String} field
	 * @returns {undefined}
	 */
	sortBy: function(listingPrefix, field){
		
		var oldField = $("#"+listingPrefix+"_sortField").val();
		
		if(field === oldField){
			$("#"+listingPrefix+"_sortDirection").val("asc" === $("#"+listingPrefix+"_sortDirection").val() ? "desc" : "asc");
		}else {
			$("#"+listingPrefix+"_sortField").val(field);
			$("#"+listingPrefix+"_sortDirection").val("asc");
		}
		
		$("#"+listingPrefix+"_actionTrigger").val("sort");
		Listing.update(listingPrefix, true);
	},


	/**
	 * 
	 * @param {type} listingPrefix
	 * @param {type} field
	 * @returns {undefined}
	 */
	displaySortBy: function(listingPrefix, field){
		
		
		$(".orderDesc", "#"+listingPrefix).removeClass('orderDesc');
		$(".orderAsc", "#"+listingPrefix).removeClass("orderAsc");

		$("#"+listingPrefix+"_"+field).addClass($("#"+listingPrefix+"_sortDirection").val() === 'asc' ? "th-asc" : "th-desc");
	},


	/**
	 * 
	 * @param {type} listingPrefix
	 * @param {type} pagenum
	 * @param {type} actionTrigger
	 * @returns {undefined}
	 */
	changePage: function(listingPrefix, pagenum, actionTrigger){
		
		actionTrigger = actionTrigger === undefined ? "pagenum" : actionTrigger;
		var askedPage = pagenum;
		var current = $("#"+listingPrefix+"_pagenum").val();
		if(pagenum === 'prev'){
			askedPage = current*1-1;
		}
		
		if(pagenum === 'next'){
			askedPage = current*1+1;
		}
		
		$("#"+listingPrefix+"_pagenum").val(askedPage);
		$("#"+listingPrefix+"_actionTrigger").val(actionTrigger);
		Listing.update(listingPrefix, false, false, pagenum);
	},


	/**
	 * 
	 * @param {type} listingPrefix
	 * @param {type} nbPerPage
	 * @returns {undefined}
	 */
	changeNbPerPage: function(listingPrefix, nbPerPage){
		
		$("#"+listingPrefix+"_nbperpage").val(nbPerPage);
		$("."+listingPrefix+"_nbperpage option").attr('selected',false);
		$("."+listingPrefix+"_nbperpage [value='"+nbPerPage+"']").attr('selected',true);
		$("select."+listingPrefix+"_nbperpage").val(nbPerPage);
		$("#"+listingPrefix+"_actionTrigger").val("nbperpage");
		
		Listing.update(listingPrefix, true);
	},
			
	/**
	 * 
	 * @param {type} listingPrefix
	 * @param {type} nbPerPage
	 * @returns {undefined}
	 */
	updateDisplayMode: function(listingPrefix, displayMode){
		
		$("#"+listingPrefix+"_displayMode").val(displayMode);
		$("."+listingPrefix+"_displayMode option").attr('selected',false);
		$("."+listingPrefix+"_displayMode [value='"+displayMode+"']").attr('selected',true);

		$("#"+listingPrefix+"_actionTrigger").val("displayMode");
		
		Listing.update(listingPrefix, true);
	},

	update: function (listingPrefix, resetPage, hasStorage, param) {
		if(MyForm.runningRequest != null){
			MyForm.runningRequest.abort();
		}

		if(listingPrefix == undefined){
			listingPrefix = Listing.getListingName();
		}

		$('#'+listingPrefix+'_container .placeholder').hide();
		
		resetPage	= resetPage === undefined ? true : resetPage;
		hasStorage	= hasStorage === undefined ? false : hasStorage;
		
		// Gather columns to display
		$("#"+listingPrefix+"_loading").fadeIn();

		if(resetPage) {
			// CheckAlive.forceCheck(function(){
				Listing.changePage(listingPrefix, 1, $("#" + listingPrefix + "_actionTrigger").val())
			// });
			return;
		} else {
			Listing.loader('show', listingPrefix);
			$("#"+listingPrefix+"_listingLoader:hidden").fadeIn();

            if ('emailBoxListing' == listingPrefix) {
                // Close current panel
                Panel.prototype.close();
            	// Remove param folder in URL
				if (location.href.indexOf('folders=') > -1) {
					var url = document.location.href;
					window.history.pushState({}, "", url.split("&")[0]);
				}
            	if (('next' != param && 'prev' != param && 'search' != param) || undefined == param) {
					// Clean search
					if ('' != $('#emailBoxListing_filter_search').val()) {
						$('#emailBoxListing_filter_search').val('');
						$('#emailBoxListing_input_search').val('');
					}
				}
            }
			$("#"+$("#"+listingPrefix+"_filterFormName").val()).submit();
		}

		var elem = (hasStorage === true) ? undefined : window.event;
		
		if ((elem && $(elem.target).parents('.searchEngineContent > form').length) || hasStorage) {
			
			var formFilter  = null;
			var listingname = '';

			if ($("#"+$("#"+listingPrefix+"_filterFormName").val()).length) {
				formFilter = $("#"+$("#"+listingPrefix+"_filterFormName").val());
				listingname = listingPrefix;
			} else {
				formFilter = $("#"+listingPrefix);
				listingname = Listing.getListingName();
			}
			
			localStorage.setItem('listingQuery', formFilter.serialize());
			localStorage.setItem('listingName', listingname);
		}

		MyFacture.loadThirdQtip();
		MyFacture.linkedDocsQtip();
	},
	
	updateColumnDisplay : function(listingPrefix){
		var filters = $("#"+$("#"+listingPrefix+"_filterFormName").val()).serialize();
		$.ajax({
			url			: '/?_f=listing&action=updateColumnDisplay&listingPrefix='+listingPrefix,
			data		: filters,
			type		: 'POST',
			dataType	: 'json'
		});
	},

	resetColumnDisplay : function(listingPrefix){
		
		$.ajax({
			url			: '/?_f=listing',
			data		: {
				action			: 'resetColumnDisplay',
				listingPrefix	: listingPrefix
			},
			type		: 'POST',
			dataType	: 'json',
			success		: function(data){
				
				var selecteds = [];
				
				if(data.defaultColumns != []){
					
					$('#'+listingPrefix+'_displayedColumnsContainer').empty();
					
					var cpt = 0;
					
					for (var i in data.defaultColumns){
						var $inputs = $('<input />').attr('type', 'hidden').attr('name', listingPrefix+'_displayedColumns['+cpt+']').attr('id', listingPrefix+'_displayedColumns['+cpt+']').val(data.defaultColumns[i]);
						$inputs.appendTo('#'+listingPrefix+'_displayedColumnsContainer');
						cpt++;
						selecteds.push(data.defaultColumns[i]);
					}
					
					$(".displayColumns").find('select').multipleSelect('setSelects', selecteds);
					
					Listing.update(listingPrefix, false);
				}
			}
		});
	},
	
	
	refresh: function(prefix, data, metas){	
		
		if(data.resetFilter === 'Y'){
			return Utils.reload();
		}
		
		// Check if user logout
		CheckAlive.performCallback(data);

		$("#"+prefix+"_actionTrigger").val("");
		$("#"+prefix+"_sortField").val(metas.sortField);
		$("#"+prefix+"_sortDirection").val(metas.sortDirection);
		$("#"+prefix+"_pagenum").val(metas.pageNum);
		$("#"+prefix+"_nbperpage").val(metas.nbPerPage);
		$("#"+prefix+"_filterdisplayed").val(metas.filterDisplayed);
		
		$("#"+prefix+"_container").html(data.listing);
		
		$("#"+prefix+"_filterformated").html(data.filterformated);

		$("#"+prefix+"_nbTotal").html(metas.nbTotal);
		
		if(Utils.exists(prefix+"_subEngineContent") && data.subEngine && (data.actionTrigger === '' || data.actionTrigger === 'step' || data.actionTrigger === 'deliverystep' || data.actionTrigger === 'allsteps' || data.actionTrigger === 'period')){
			Listing.updateSubEngine(prefix, data.subEngine);
		}

		$("."+prefix+"_pagination").html(data.paging);
		MyFacture.customForm();
		Qtip.init();
		MyFacture.loadThirdQtip();
		MyFacture.linkedDocsQtip();
		MyFacture.loadDeadlinesQtip();

		Listing.displaySortBy(prefix, metas.sortField);
		Listing.checkFilter(prefix, data);
		
		if (parseInt(metas.nbTotal, 10) === 0 || false == metas.nbTotal){
			$('#'+prefix+'_container .noDocument').show();
		} else {
			$('#'+prefix+'_container .noDocument').hide();
		}

		$("#"+prefix+"_loading").fadeOut();
		Listing.loader('hide', prefix);
		
		if($('#'+data.listingName+'_container').hasClass('linkingListing')){
			$('#'+data.listingName+'_container tr *[onclick]').removeAttr('onclick');
			$('#'+data.listingName+'_container td a[href]').attr('href', 'javascript:;');
		}
		
		if($('#'+data.listingName+'_container').hasClass('linkingListing') && $('.linkedContainer li:not(.template)').length > 0){
			
			
			
			$('.linkedContainer li:not(.template)').each(function(){
				var reg			= new RegExp('linked-pay-', 'g');
				var reg2		= new RegExp('linked-related-', 'g');
				var reg3		= new RegExp('linked-', 'g');
				var linkedID	= $(this).attr('id').toString().replace(reg, '').replace(reg2, '').replace(reg3, '');
				
				
				var actionCheck = $('#'+data.listingName+'_container tr#'+data.prefix+'_'+linkedID).find(".groupedActionChecker");
				actionCheck.prop('checked', true);
			});
		}

		$('#selectAllPages').length > 0 && Listing.isAvailableSelectAllPages(metas.nbTotal <= parseInt($('#selectAllPages').attr('limit')));

		// Refresh column sorting
		Listing.initSelectColumns(prefix);

		$('#groupedActionContainer').hide();
		$('.listingTools:hidden').show();

        if(Utils.browserDetails.name !== 'Apple Safari' && $('#'+prefix+'_container table.listingtable').find('th.th-draggable').length > 0) {
            Listing.initDragTable(prefix);
        }
		
		

		
		return true;
	},
	
	
	/**
	 * 
	 * @returns {void}
	 */
	freezeFilters : function(){
		
		var $frozen		= $('.frozen');
		var $underlabel = $frozen.closest('.filter_underlabel');
		var $checkboxes = $frozen.find('input[type=checkbox]');
		
		$underlabel.find('.token-input-list *').unbind('change').unbind('focus').unbind('click');
		$underlabel.find('input[type=text]').unbind('change').unbind('focus').unbind('click').unbind('keyup').unbind('keydown').bind('keydown', function(){
			$(this).val('');
			return false;
		});
		
		$underlabel.find('.ui-selectmenu').attr('aria-disabled', 'true');
		$frozen.unbind('change').unbind('focus').unbind('click').unbind('change').unbind('keyup').unbind('keydown');
		
		$checkboxes.unbind('change').unbind('click').removeAttr('onchange');
		$checkboxes.unbind('click').bind('click', function(event){
			if($(this).prop('checked')){
				$(this).prop('checked', false);
			}else{
				$(this).prop('checked', true);
			}
			event.preventDefault();
			return false;
		});
		
		$frozen.bind('click', function(){
			MyWindow.alert(Loc.g('Vous ne pouvez pas filtrer le listing dans ce contexte'), {type : 'warning'});
		});
		
	},


	/**
	 * 
	 * @param {type} currentDropDown
	 * @param {type} listingPrefix
	 * @returns {undefined}
	 */
	updateExportsDropDown: function(currentDropDown, listingPrefix){
		var val = currentDropDown.val();
		$("."+listingPrefix+"_exportDropDown").each(function(){
//			$(this).selectmenu("value", val);	
			$(this).val(val);	
		});
	},

	/**
	 * 
	 * @param {type} listingPrefix
	 * @param {type} type
	 * @returns {undefined}
	 */
	exportIt: function(listingPrefix, type) {

		var start				= {
			mode				: $("."+listingPrefix+"_exportDropDown").val()
		};
		if (listingPrefix == "campaignrecipientsListing") {
			start.campaignid	= $('#campaignId').val();
		}

		var options = {
			title: Loc.g("Export CSV"),
			buttons: [
                {
                    text: Loc.g("Annuler"),
					'class': 'btn btn-default',
					click: function() {
                        $(this).dialog("close");
                    }
                },
                {
					text: Loc.g("Exporter"),
					'class': 'btn btn-primary',
					click: function() {
						var redirectUrl	= false;

						$.ajax({
							url			: MyFacture.buildUrl('listing'),
							type		: 'POST',
							async		: false,
							dataType	: 'json',
							data		: {
								action	: 'doExportCSV',
								charset	: $('#export_charset').val(),
								formatimport : $('#export_formatimport').prop('checked') ? 'Y' : 'N'
							},

							success: function (data) {
								var charset				= data.charset;
								var formatimport		= data.formatimport;

								if (listingPrefix == "campaignrecipientsListing") {
									redirectUrl = MyFacture.buildUrl("export&charset="+charset+"&formatimport="+formatimport+"&type="+type+"&listing="+listingPrefix+"&mode="+start.mode+"&campaignid="+start.campaignid);
								} else {
									redirectUrl = MyFacture.buildUrl("export&charset="+charset+"&formatimport="+formatimport+"&type="+type+"&listing="+listingPrefix+"&mode="+start.mode);
								}
							}
						});

						if(redirectUrl) {
							Utils.relocate(redirectUrl);

							// puis, on close la popup
							MyWindow.close();
						}
					}
				}
			],
			width: 600
		};

		var fileOpt = {action: "exportCSV", listingPrefix : listingPrefix, type: type};
		MyWindow.load("listing", fileOpt, options);
	},
	
	moreInformationPDF: function(listingPrefix, type){
		
		var title = Loc.g("Informations supplémentaire pour l'export");
		var modePage = $("."+listingPrefix+"_exportDropDown").val();
		var displayTotals = 'N';
		var currency = $('#'+listingPrefix+'_filter_currency').val();
		switch(listingPrefix){
			case 'docestimatesListing':
			case 'docinvoicesListing':
			case 'doccreditnotesListing':
			case 'docdeliveriesListing':
			case 'docordersListing':
			case 'docproformasListing':
			case 'purdocordersListing':
			case 'purdocdeliveriesListing':
			case 'purdocinvoicesListing':
			case 'opportunitiesListing':
			case 'expensesListing':
			case 'ticketsListing':
			case 'purdoccreditnotesListing':
				displayTotals = 'Y';
				break;
				
		}
		var options = {
			title	: title,
			buttons	: [
                {
                    text : Loc.g("Annuler"),
					'class': 'btn btn-default',
					click :  function(){$(this).dialog("close")}
                },
                {
					text : Loc.g("Exporter"),
					'class': 'btn btn-primary',
					click : function(){
							$("#moreInformationPDFForm").submit();
							$(this).dialog("close");
						}
				}
			],
			callback: function () {
				Listing.preapreMoreInformationPDF(listingPrefix);
			}
		};
		
		var params = {
			action:"moreInformationPDF", 
			displayTotals:displayTotals, 
			modePage:modePage, 
			type:type, 
			listingPrefix:listingPrefix, 
			currency:currency
		};
		
		MyWindow.load("listing", params, options);
	},
	
	preapreMoreInformationPDF: function (listingPrefix) {

		var formId = "moreInformationPDFForm";
		var options = {success: function (data) {
				var formIsOk = MyForm.processJson(data, "moreInformationPDFForm");
				if (formIsOk) {
				}
			}, dataType: "json"};

		var data = {action: 'getMoreInformationPDF'};
		if(listingPrefix == 'campaignrecipientsListing') {
			data.campaignid = $('#campaignId').val();
		}
		
		MyForm.prepare(formId, "listing&" + $.param(data), options, true);
		MyFacture.initEvent();

	},
	
	
	/**
	 * 
	 * @param {type} listingPrefix
	 * @param {type} type
	 * @returns {undefined}
	 */
	exportItPurchases: function(listingPrefix, type){
			MyFacture.relocate("purchases_export&type="+type+"&listing="+listingPrefix+"&mode="+$("."+listingPrefix+"_exportDropDown").val(), true);
	},


	/**
	 * 
	 * @param {type} prefix
	 * @param {type} data
	 * @returns {undefined}
	 */
	checkFilter: function(prefix, data){
		if(data.filtered === 'filtered'){
			$("#"+prefix+"_filterNotification").show();
			MyFacture.customForm($("#"+prefix+"_filterNotification"));
		}else {
			$("#"+prefix+"_filterNotification").hide();
		}
	},


	/**
	 * 
	 * @param {string} prefix
	 * @returns {undefined}
	 */
	resetFilter: function(prefix){
		$('.placeholder').remove();
		$("#"+prefix+"_resetFilter").val("Y");
		$("#"+prefix+"_actionTrigger").val("reset");
		Listing.update(prefix, true);

	},

	/**
	 * 
	 * @param {type} prefix
	 * @param {type} data
	 * @returns {undefined}
	 */
	updateSubEngine: function(prefix, data){
		
		if(data.engineType === 'total'){
//			$("#"+prefix+"_subEngineContent")[0].innerHTML = data.engineContent;
			$("#"+prefix+"_subEngineContent").html(data.engineContent);
		}
	},
	
	checkAllSteps: function(prefix){
		
		if($('#'+prefix+'_checkStep input[id='+prefix+'_step_all]').prop('checked')){
			$('#'+prefix+'_checkStep input[type=checkbox]').attr('checked', true);
		} else {
			$('#'+prefix+'_checkStep input[type=checkbox]').attr('checked', false);
		}
		$('#'+prefix+'_checkStep input[type=checkbox]').button('refresh');
		$("#"+prefix+"_actionTrigger").val("allsteps");
		Listing.update(prefix, true);

	},
	
	changePeriod: function(prefix, type){
		
		if('custom'===$("#"+prefix+"_filter_period_"+type+" option:selected").val()){
			$("#"+prefix+"_period_"+type+"_custom").fadeIn();
			MyFacture.customForm();
		}else {
			$("#"+prefix+"_period_"+type+"_custom").fadeOut();
		}
		$("#"+prefix+"_actionTrigger").val("period");
		Listing.update(prefix, true);
	},
	
	updateFilterDisplay: function(prefix){
		$('#'+prefix+'_filterDisplayed').val($('#'+prefix+'_filterDisplayed').val() === 'Y' ? "N" : "Y" );
		$("#"+prefix+"_actionTrigger").val("filterdisplayed");
		Listing.update(prefix, true);
	},
	
	changeSteps: function(prefix){
		Listing.updateSteps(prefix);
		$("#"+prefix+"_actionTrigger").val("step");
		Listing.update(prefix, true);
	},
	
	changeDeliverySteps: function(prefix){
		Listing.updateDeliverySteps(prefix);
		$("#"+prefix+"_actionTrigger").val("deliverystep");
		Listing.update(prefix, true);
	},

	updateSteps: function(prefix){
		var checked = true;
		$('#'+prefix+'_checkStep input[type=checkbox][name!=filter_step_all]').each(function(){
			if(!$(this).prop('checked')){
				checked = false;
			}
		});

		$('#'+prefix+'_checkStep input[id='+prefix+'_step_all]').attr('checked', checked);
		$('#'+prefix+'_checkStep input[id='+prefix+'_step_all]').button('refresh');
	},

	updateDeliverySteps: function(prefix){
		var checked = true;
		$('#'+prefix+'_checkDeliveryStep input[type=checkbox][name!=filter_deliverystep_all]').each(function(){
			if(!$(this).prop('checked')){
				checked = false;
			}
		});

		$('#'+prefix+'_checkDeliveryStep input[id='+prefix+'_deliverystep_all]').attr('checked', checked);
		$('#'+prefix+'_checkDeliveryStep input[id='+prefix+'_deliverystep_all]').button('refresh');
	},
	
	updateIdent: function(prefix){
		var selector = $('#'+prefix+'_filter_ident');
		var val = selector.val();
		clearTimeout(selector.attr('timeout'));
		selector.attr('timeout',setTimeout(function() {Listing.update(prefix, true);}, 500) );		
	},
			
			
	updateLocFilter : function(prefix){
		
        var country = $('#'+prefix+'_filter_country').val();
		
		if (country != undefined && country.length == 1){
			
			var countryCode = country[0];
			switch(countryCode){
				case 'FR' : 
					$('.locFilterDept').show();
					$('.locFilterZip').show();
					MyFacture.customForm();
					break;
				default : 
					$('.locFilterDept').hide();
					$('.locFilterZip').hide();
					break;
			}
			
		} else {
			
			$('.locFilterDept').hide();
			$('.locFilterZip').hide();
			
		}
		
	},
	
	updateStateFilter : function(prefix){
		var country = $('#'+prefix+'_filter_country').val();

		if (country != undefined && country.length == 1){
			
			var countryCode = country[0];
			
			if(countryCode != 'FR' && countryCode != ''){
				
				MyFacture.post('address', {action : 'loadStates', country : countryCode}, function(data){

                    $('.locFilterState').html('');
                    var select = '<select id="prospectsListing_filter_state" name="prospectsListing_filter_state[]" class="stateFilter mt4" onchange="" multiple="multiple" selectall="false" placeholder="Choisissez des états" style="display: none;">';
                    for(var i in data.states){
                        select += '<option value="'+data.states[i].name+'">'+data.states[i].formattedName+'</option>';
					}
                    select += '<select/>';
                    $('.locFilterState').html(select);
                    MyFacture.customForm();
                    $('.locFilterState').show();
                    $('.stateFilter').attr('onchange', 'Listing.update("'+prefix+'")');
				}, 'json');
				
			}else{
                $('.locFilterState').html('');
				$('.locFilterState').hide();
			}
			
		} else {
            $('.locFilterState').html('');
			$('.locFilterState').hide();
		}
		
		
	},
			
	updateAlphanumFilter : function(listingName, inputName, value){
		$('#'+listingName+'_filter_'+inputName).val(value);
		$('#'+listingName+'_searchEngine .filterChar').removeClass("current");
		$('#'+listingName+'_searchEngine #char'+value).addClass("current");
		Listing.update(listingName, true);
	},
	
 	updateDeclinationFilter: function(prefix){
		
		var useDeclination	= $('#'+prefix+'_filter_useDeclination').val();

		// $(".itemsListing_filter_decliValues").multipleSelect('uncheckAll');

		if (useDeclination == "N"){
			
			$(".declinationSearch.combinedDecli").hide();
			$(".declinationSearch.decliValues").hide();
			
		} else if(useDeclination == "Y"){
			
			$(".declinationSearch.combinedDecli").show();
			$(".declinationSearch.decliValues").show();
			
		}else {
			
			$(".declinationSearch.combinedDecli").show();
			$(".declinationSearch.decliValues").hide();
			MyFacture.customForm();
			
		}

	},
	
	tagSelectChanged: function(me) {
		var el		= $(me);
		var parts	= el.attr('id').split('_');
		var lastVal = el.parent().find('#tags_select_old').val();
		
		if(parts[2] === 'tags' && parts[3] === 'select') {
			var parent		= el.parent();
			var selector	= 'input[id$="Listing_filter_tags"]:not([id^="token-input"])';
			switch(el.val()) {
				case 'with':
				case 'without':
					parent.find(selector).tokenInput('clear');
					parent.find('.token-input-list').hide();
					break;
				case 'not':
					parent.find(selector).tokenInput('clear');
					parent.find('.token-input-list').prop('e_autotag_max', '1');
					break;
				default:
					switch(lastVal) {
						case 'with':
						case 'without':
							// if it's a new page and the tokenInput don't exists
							if(!parent.find('.token-input-list').length) {
								TokenInput.autoTag(selector,$(selector).attr('e_autotag'));
							}
							
							parent.find(selector).tokenInput('clear');
							parent.find('.token-input-list').show();
							break;
					}
					break;
			}
		}
		el.parent().find('#tags_select_old').val(el.val());
	},
	
	assignedStaffChanged: function(me) {

		var el		= $(me);
		
		if(el.val() == 'select') {
			el.parent(".filter_underlabel").find(".tokenStaff").show();
		}else {
			el.parent(".filter_underlabel").find(".tokenStaff").hide();
		}
		
	},
	
	saveSearch : function(listingName){
		
		var formID = "saveSearchForm";
		
		var data = {
			action		: "saveSearchForm", 
			listingName	: listingName,
		};
		
		var options = {
			title :  Loc.g('Sauver la recherche'),
			buttons:
					[
                        {text: Loc.g("Annuler"), click: function() {
                            $(this).dialog("close");
                        }},
                        {text: Loc.g("Enregistrer"), click: function(btn) {
							!$('body').data('savedSearchFormDisabled') && $("#" + formID).submit();

							MyForm.toggleDisabledForm({
								btn : $(btn.currentTarget),
								dataToCheckOnBody : 'savedSearchFormDisabled'
							});

						}}
					],
			width: 600,
			callback: function() {
				
				var body = $('body');
				body.data('savedSearchFormDisabled', false);
				
				var options = {
					data : {action : 'saveSearchRecord'},
					dataType : 'json',
					success : function(data){
						var formOk = MyForm.processJson(data, formID);
						if(formOk){
							var body = $('body');
							if(data.action == 'created' && $('#savedSearches').length > 0){
								$('#savedSearches').find('option').removeAttr('selected');
								$('#savedSearches').append('<option value="'+data.searchID+'" selected="true">'+data.searchName+'</option>');
//								$('#savedSearches').selectmenu('destroy').selectmenu();
							}
							MyWindow.close();
						} else {
							MyForm.toggleDisabledForm({
								btn : $('#popupWindow').next().find('button:first'),
								dataToCheckOnBody : 'savedSearchFormDisabled',
								toEnabled : true
							});
						}
					}
				};
				
				MyForm.prepare(formID, 'listing', options, true);
				MyFacture.customForm('#'+formID);
			}
		};
		
		MyWindow.load("listing", data, options);
	},

	editSearch : function(searchid){

		$("#btnEditSaveSearch_"+searchid).css('pointer-events','none');
		var savedSearchName = $("#searchname_"+searchid).html();

		$("#searchname_"+searchid).html(
			'<input type="text" id="newSavedSearchName_'+searchid+'" name="newSavedSearchName_'+searchid+'" value="'+savedSearchName+'"/>' +
			'<a href="javascript:;" class="btn btn-primary btn-small btn-action" onclick="Listing.recordEditSaveSearch('+searchid+')">' +
			'<i class="fa fa-check fa-13" style="margin:2px;"><xsl:comment /></i>' +
			'</a>'
		);
	},

	recordEditSaveSearch : function(searchid){
		var newSaveName = $("#newSavedSearchName_"+searchid).val();
		newSaveName = newSaveName.replace(/(<([^>]+)>)/ig,"");

		MyFacture.post('listing', {action : 'recordEditSaveSearch', searchid : searchid, newSaveName : newSaveName}, function(data){
			if(data.result == 'ok'){
				$("#btnEditSaveSearch_"+searchid).css('pointer-events','auto');
				$("#searchname_"+searchid).html(newSaveName);
			} else{
				MyWindow.alert(Loc.g("Une erreur s'est produite, votre recherche sauvegardée n'a pas été mise à jour."), {type:'error'});
			}
		}, 'json');
	},
	
	injectSearch : function(){
		Listing.injectSearchWithID($('#savedSearches').val());
	},
	
	injectSearchWithID : function(searchID){
		if(searchID != ""){
			MyFacture.post('listing', {action : 'injectSearch', searchID : searchID}, function(data){
				Utils.reload();
			}, 'json');
		}
	},
	
	manageSavedSearches : function(listingName){
//		var formID = "saveSearchForm";
		
		var data = {
			action		: "manageSavedSearches", 
			listingName	: listingName,
		};
		
		var options = {
			title :  Loc.g('Liste des recherches sauvegardées'),
			buttons:
					[
						{
							text: Loc.g("Fermer"), 
							click: function() {
								$(this).dialog("close");
							}
						}
					],
			width: 800,
			callback: function() {
				Qtip.init();
			}
		};
		
		MyWindow.load("listing", data, options);
	},
	
	deleteSearch : function(searchID){
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression d'une recherche sauvegardée pour ce listing"),
			type		: "warning",
			width		:350,
			buttons		: [
                {text : Loc.g("Non"), click : function(){$(this).dialog("close");}},
                {text :
					Loc.g("Oui"),
					click : function(){
						var datas = {
							action		: "deleteSearch",
							searchID	: searchID
						};
						MyFacture.post("listing", datas, function(data){
							// Delete line in table
							$('li#search_'+data.searchID).fadeOut(300, function(){$(this).remove();});
							// Update select element (if it's here)
							if($('#savedSearches').length > 0){
								$('#savedSearches option[value='+data.searchID+']').remove();
//								$('#savedSearches').selectmenu('destroy').selectmenu();
							}

						}, "json");
						$(this).dialog("close");
					}
				}
			]
		};
		MyWindow.alert(Loc.g("Voulez-vous supprimer cette recherche ?"), options);
	},

	showSavedSearchLink : function(searchID, forceDisplay){

		var href		= window.location.href;
		var splitHref	= href.split('&');
		var tabOption	= splitHref.slice(1);
		var target		= splitHref.splice(0,1);

		var $searchBlock	= $('#search_'+searchID+' .search_link');
		var $inputLink		= $searchBlock.find('.input_link');
		if($inputLink.val()  == '') {
			if(tabOption.length > 0){
				$.each(tabOption, function(index, option){
					target += '&' + (option.indexOf('savedSearch') >= 0 ? 'savedSearch=' + searchID : option);
				});		
			} else {
				target += '&savedSearch=' + searchID;
			}
			target += target.indexOf('savedSearch') < 0 ? '&savedSearch=' + searchID : '';

			$inputLink.val(target);

			var btnCopy = $inputLink.parent().find('.copyButton');

			Listing.prepareCopyToClipBoard(btnCopy, $inputLink);
		} 
		
		forceDisplay ? $searchBlock.slideDown(200) : $searchBlock.slideToggle(200);
	},

	showSavedSearchFilters : function(searchID, forceDisplay){
		var $searchBlock = $('#search_'+searchID+ ' .filter_details');
		forceDisplay ? $searchBlock.slideDown(200) : $searchBlock.slideToggle(200);
	},
	
	showSavedSearchInfos : function(searchID){
		if($('#search_'+searchID+' .filter_details:visible').length == 0 || $('#search_'+searchID+' .search_link:visible').length == 0){
			Listing.showSavedSearchFilters(searchID, true);
			Listing.showSavedSearchLink(searchID, true);
		} else {
			Listing.showSavedSearchFilters(searchID);
			Listing.showSavedSearchLink(searchID);
		}
		
		$('#search_'+searchID).find('a.showhide .fa').toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
	},
	
	changeToExistingSearch : function(){
		$('#search_typeExisting').attr('checked', true);
		var searchID	= $('#search_searchID').val();
		var isPrivate	= $('#search_searchID option[value='+searchID+']').attr('isPrivate');
		
		$('input[name=search_private]').removeAttr('cheked');
		$('input[name=search_private][value='+isPrivate+']').attr('checked', true);
	},
	
	handleOrigin4Listing : function(listingName){
		
		var selectval		= $('#'+listingName+'_filter_originType option:selected').val();
		var $originSearch	= $('.originSearch');
		
		$('.token-input-list', $originSearch).remove();
		
		if(selectval == 'pos'){
			
			TokenInput.autoCashtill('#'+listingName+'_filter_originid', 1, 'true', '');
			$originSearch.css('display', 'inline');
			
		}else {
			$originSearch.css('display', 'none');
		}
		
	},
	
	/**
	 * @param $('btn') btnActionCopy
	 * @param $('input') inputToCopy
	 */
	prepareCopyToClipBoard : function(btnActionCopy, inputToCopy){
		
		btnActionCopy.qtip({
			style : {
				classes : 'custom-qtip',
				def		: false,
			},
			position: {
				viewport: true,
				my : 'top center',
				at : 'bottom center',
			},
			show : {
				event : 'copy'
			},
			hide : {
				delay: 1000,
				fixed: true
			},
			content: {
				text: Loc.g('Lien copié dans le presse-papier')
			}
		});
		
		btnActionCopy.click(function(){

			inputToCopy.select();
			if(document.execCommand('copy')){
				inputToCopy.css('background-color', '#8FDB7D').css('color', 'white');
				btnActionCopy.trigger('copy');
				setTimeout(function(){
					inputToCopy.css('background-color', '').css('color', '');
				}, 1000);
			}
			return false;

		});

		
		
	},
		
	getAllElementsIds : function(prefix){
		var listingname	= Listing.getListingName().replace(/Listing$/, 'List').replace(/List$/, '');
		var url			= '/?_f=listing&action=getAllIds&listingname=' + listingname + (!$.isNumeric(prefix) ? '&prefix='+prefix : '') + '&selectAllPages';
		
		$.ajax({
			url :		url,
			type :		'POST',
			dataType :	'json',
			async:		false,
			success:	function(allElementsIds){
				Listing.allLinkedIds = allElementsIds;
			}
		});
	},

	checkSelectAllPages : function(){

		var selected	= $('#groupedAction option:selected');
		var limit		= selected.attr('selectAllLimit') !== undefined ? parseInt(selected.attr('selectAllLimit')) : parseInt($('#selectAllPages').attr('limit'));

		if(selected.val() == 'nothing' || selected.attr('disableSelectAll') !== undefined){
			Listing.isAvailableSelectAllPages(false, true);
		} else {
			nbTotal = parseInt($('[id*="Listing_nbTotal"]').html());
			Listing.isAvailableSelectAllPages(nbTotal <= limit);
		}
	},

	isAvailableSelectAllPages : function(bool, toHide){

		toHide		= toHide !== undefined ? toHide : false;
		var limit	= $('#groupedAction option:selected').attr('selectAllLimit') !== undefined ? $('#groupedAction option:selected').attr('selectAllLimit') : $('#selectAllPages').attr('limit');
		var qtip	= $('#selectAllPagesQtip');

		qtip.qtip("destroy");

		$('#selectAllPages').closest('label').toggleClass('hidden', toHide);
		$('#selectAllPagesLabel').toggleClass('hidden', toHide);
		$('#selectAllPagesQtip').toggleClass('hidden', toHide);

		if(!toHide){

			if(bool){
				$('#selectAllPages').removeAttr('disabled').css('cursor', '');
				qtip.addClass('hidden');
			} else {
				$('#selectAllPages').attr('disabled', 'disabled').removeAttr('checked').css('cursor', 'default');
				qtip.removeClass('hidden');

				
				qtip.qtip({
					style : {
						classes : 'custom-qtip',
						def		: false
					},
					position: {
						viewport: true
					},
					show : {
						event : 'mouseover'
					},
					hide : {
						event: 'mouseout' 
					},
					content: {
						text : window.i18n.n__(
						    "La sélection de l'ensemble des pages d'un listing pour cette action est limitée à %(nb)d élément",
						    "La sélection de l'ensemble des pages d'un listing pour cette action est limitée à %(nb)d éléments",
						    limit,
						    {'nb' : limit}
						)
					}
				});
			}
		}
	},

	prepareQtipListing: function(listing){

		var table = '#' + listing +'Table';

		switch(listing){
			case 'ticketsListing':
				var elementtype = 'ticket';
				break;
			case 'opportunitiesListing':
				var elementtype = 'opportunity';
				break;
		}

		$.each($(table + ' .projects[elementid]'), function(k, v) {
			var me 			= $(v);
			var elementid	= me.attr('elementid');
			
			me.qtip({
				style : {
					classes : 'custom-qtip rich-qtip',
					def		: false
				},
				position: {
					viewport: true,
					my : 'top center',
					at : 'bottom center'
				},
				show : {
					event : 'mouseover'
				},
				hide : {
					event: 'mouseout', 
					fixed: true,
					delay: 100
				},
				content:{
					ajax: {
						url: '/?_f=listing', 
						type: 'GET',
						data: {
							action		: 'showProjects', 
							elementid	: elementid, 
							elementtype : elementtype
						},
						once: true
					}
				}
			});
		});

	},

    updateTitle: function($this, target){
		var target 		= target === undefined ? '#pageTitle' : target;
		var selectorId 	= $this[0].id;
		var text		= $("#"+selectorId+" option:selected").text();
		$(target).html(text);
	},

	loadAgendaTab : function(startTime, endTime, days, view, forceLocation){
		if($('#listing-fullcalendar table').length === 0){
			MyFacture.customForm();
			Agenda.initCalendar(startTime, endTime, days, view, forceLocation);
		}
	},
};
